// Regexy nad názvy skupín podkategórií z nativního menu jipos.sk → ikona
// skupiny. Stejné pořadí a ikony jako cs/menuModel.js (PRVNÍ shoda vyhrává).
// Názvy ověřené v dev/sk/home.html (22. 9. 2026), kořeny bez obdoby v menu přeložené.
export default {
  groupIconRules: [
    // Zahrada
    [/reťaz|retaz/i, 'chainsaw'],
    [/ručné píl|rucne pil|pílk|pilk/i, 'handsaw'],
    [/krovinorez|strunov/i, 'trimmer'],
    [/kosačk|kosack|vertikut|prevzduš|prevzdus|kultiv/i, 'mower'],
    [/zavlažov|zavlazov|postrek|hadic/i, 'droplets'],
    [/záhradné náradie|zahradne naradie|rýľ|ryl|lopat|motyk/i, 'shovel'],
    [/vrták|vrtak|vŕtačk|vrtack/i, 'drill'],
    [/kvetin|kvetináč|kvetinac|truhlík|truhlik/i, 'plant'],
    [/koliesk/i, 'wheelbarrow'],
    [/obrubník|obrubnik|oplotenie|plot/i, 'fence'],
    [/bazén|bazen/i, 'waves'],
    [/foliovn|fóliovn/i, 'greenhouse'],
    [/fóli|agrotext|placht|folie/i, 'layers'],
    [/osviežovač|osviezovac|dezinfek|desinfek|sprej/i, 'spray'],
    [/vták|vtak|vtáci|vtaci/i, 'bird'],
    [/merač|merac|tester/i, 'gauge'],
    [/lapač|lapac|odpudzovač|odpudzovac|plašič|plasic/i, 'bug'],
    [/domček|domcek|domčeky|domceky/i, 'home'],
    [/kompost/i, 'leaf'],
    [/fúkač|fukac|vysávač|vysavac/i, 'wind'],
    [/nábytok|nabytok|obývac|obyvac/i, 'armchair'],
    [/hnojiv/i, 'sack'],
    [/čistič|cistic/i, 'broom'],
    // Vánoce
    [/veniec|vence|venc|girland/i, 'wreath'],
    [/ozdob/i, 'bauble'],
    [/dekorác|dekorac|lešt|lest/i, 'sparkles'],
    // Dílna / stavba
    [/ohrievač|ohrievac|kúren|kuren/i, 'flame'],
    [/čerpadl|cerpadl/i, 'droplet'],
    [/uprat/i, 'broom'],
    [/kábel|kabel|káble|kable|predlžovac|predlzovac/i, 'plug'],
    [/zvár|zvar/i, 'welding'],
    [/kompresor/i, 'compressor'],
    [/zdvíhac|zdvihac|kladkostroj|naviják|navijak/i, 'hook'],
    [/vozík|vozik/i, 'trolley'],
    [/meradl/i, 'ruler'],
    [/organiz|krabič|krabic|šuplí|supli/i, 'drawers'],
    [/rezačk|rezack|lámačk|lamack/i, 'saw-blade'],
    [/maľov|malov|farb/i, 'paint-roller'],
    [/rebrík|rebrik|schodík|schodik/i, 'ladder'],
    // Nářadí
    [/nástroje aku|nastroje aku|aku náradie|aku naradie/i, 'drill'],
    [/príslušenstvo k náradiu|prislusenstvo k naradiu/i, 'cog'],
    [/regál|regal|polic/i, 'shelf'],
    // Domácnost
    [/kuchy/i, 'utensils'],
    [/kúpeľ|kupel/i, 'bath'],
    [/kancelári|kancelari/i, 'briefcase'],
    [/camping|kemp|stan/i, 'tent'],
    [/elektronik/i, 'cpu'],
    [/osvetlen|svietidl|svetl|žiarov|ziarov/i, 'bulb'],
    [/gril/i, 'grill'],
    [/chovateľ|chovatel/i, 'paw'],
    [/šport|sport/i, 'dumbbell'],
    [/botník|botnik/i, 'shoe'],
    [/odpadk/i, 'trash'],
    [/zábav|zabav/i, 'gamepad'],
    [/pre deti|hračk|hrack/i, 'gift'],
    [/oblečen|oblecen|odev/i, 'shirt'],
    [/zámk|zamk/i, 'lock'],
    [/vylepšen|vylepsen/i, 'home'],
    // Děti
    [/šmykľav|smyklav/i, 'slide'],
    [/hojdačk|hojdack/i, 'swing'],
    [/odrážad|odrazad|kolobež|kolobez|trojkolk|skateboard/i, 'scooter'],
    [/ihrisk/i, 'seesaw'],
    // Auto
    [/výbava|vybava/i, 'steering'],
    [/auto-moto|autodopl/i, 'wrench'],
    [/endoskop|kamer/i, 'camera'],
    // OOPP
    [/rukavic/i, 'hand'],
    [/okuliar/i, 'glasses'],
    [/slúchadl|sluchadl/i, 'headset'],
    [/prilb|helm/i, 'helmet'],
    [/mask|respirát|respirat/i, 'mask'],
    // obecné záchytky (až po specifických)
    [/box/i, 'package'],
    [/aku|akumul|batéri|bateri/i, 'battery'],
    [/ochran|bezpečn|bezpecn/i, 'shield'],
    [/elektrocentrál|elektrocentral|elektrick|elektro/i, 'bolt'],
    [/náradi|naradi/i, 'hammer'],
  ],
};
